import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Welcome from "@/pages/Welcome";
import ChildSetup from "@/pages/ChildSetup";
import Journey from "@/pages/Journey";
import WrapUp from "@/pages/WrapUp";
import JourneyCompleted from "@/pages/JourneyCompleted";
import { listenForPushTaps } from "@/lib/push";

export default function App() {
  useEffect(() => {
    // When the parent taps a Neo/Lyria push notification, the SW focuses
    // the tab + posts a message; we read the "speak" field and play it
    // via TTS so the voice arrives even from a cold resume.
    const stop = listenForPushTaps();
    return stop;
  }, []);

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gradient-to-br from-[#fdf6ff] via-[#fff3ec] to-[#eaf5ff]">
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/setup" element={<ChildSetup />} />
          <Route path="/journey/:journeyId" element={<Journey />} />
          <Route path="/journey/:journeyId/wrap-up" element={<WrapUp />} />
          <Route path="/journey-completed" element={<JourneyCompleted />} />
        </Routes>
      </div>
      <Toaster richColors position="top-center" />
    </BrowserRouter>
  );
}
